import { State } from "../store/reducer";
import { hasPaginationNextItems } from ".";

interface Props<TItem> {
  items: TItem[];
  pagination: Pagination;
  errorMessage: string;
}

const getReducerInitialState = <TItem>({
  items,
  pagination,
  errorMessage,
}: Props<TItem>): State<TItem> => {
  return {
    hasNextItems: hasPaginationNextItems(pagination),
    isLoading: false,
    isLoadingMore: false,
    items,
    pagination,
    hasError: false,
    errorMessage,
  };
};

export default getReducerInitialState;
